"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsUndefined_1 = __importDefault(require("../typeAssertions/valueIsUndefined"));
const areDbRoutesEqual_1 = __importDefault(require("./areDbRoutesEqual"));
const getFromDatabaseCache = ({ getCacheData, currentTimeInMillis, maxAgeInMillis, route, }) => {
    const data = getCacheData();
    const matchedRecords = data.filter((record) => (0, areDbRoutesEqual_1.default)(route, record.route));
    if (matchedRecords.length < 1) {
        return undefined;
    }
    let updatedRecord;
    matchedRecords.forEach((record) => {
        if ((0, valueIsUndefined_1.default)(updatedRecord)) {
            updatedRecord = record;
        }
        else if (record.lastUpdateTimestamp > updatedRecord.lastUpdateTimestamp) {
            updatedRecord = record;
        }
    });
    if ((0, valueIsUndefined_1.default)(updatedRecord)) {
        return undefined;
    }
    const timeSinceUpdate = currentTimeInMillis - updatedRecord.lastUpdateTimestamp;
    if (timeSinceUpdate > maxAgeInMillis) {
        return undefined;
    }
    return updatedRecord.data;
};
exports.default = getFromDatabaseCache;
